import React from "react";

const FileNameFormatter = ({ fileName }) => {
    const formatFileName = (fileName) => {
        if (!fileName || typeof fileName !== "string") return "";

        const parts = fileName.split(".");
        if (parts.length < 2) return fileName;

        const name = parts.slice(0, -1).join(".");
        const extension = parts[parts.length - 1];

        const truncatedName = name.length > 20 ? name.slice(0, 20) + "..." : name;

        return `${truncatedName}.${extension}`;
    };

    return <span>{formatFileName(fileName)}</span>;
};

export default FileNameFormatter;
